module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 328
// module chunks = 0